import { Navigate } from "react-router-dom";
import useAdminAuth from "../../hooks/useAdminAuth";

export default function AdminRoute({ children }) {
  const isAdminLoggedIn = useAdminAuth();

  return isAdminLoggedIn ? children : <Navigate to="/admin/" />;
}
